import { styled } from "@mui/system"
import { Box, IconButton } from "@mui/material"

export const SnackbarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "bgColor",
})(({ theme, bgColor }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background:
    bgColor || theme.theme.customGradients.primary || theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(2, 3),
  borderRadius: 0,
  width: "fit-content",
  maxWidth: "100%",
}))

export const IconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}))

export const Divider = styled(Box)(({ theme }) => ({
  margin: `0 ${theme.spacing(2)}`,
  height: "27px",
  width: "1px",
  backgroundColor: theme.palette.common.white,
}))

export const CloseButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
}))
